import Popup from "reactjs-popup";
import React, { Component } from "react";
import newsRecords from "../api/newsRecords";
import { getDateFormat } from '../../../helpers/helpers';
import icons from "../../../helpers/iconMenu";
import newsCategories from "../api/newsCategories";
import Form from '../../../components/form-component/form';
import { getStaticText } from '../../../lables/lablesService';
import Table from '../../../components/table-data-component/table';
import Spinner from '../../../components/spinner-component/Spinner';

import 'reactjs-popup/dist/index.css';
import '../../../scss/os-global.scss';

class NewsRecords extends Component {

  constructor(props) {
    super(props);

    this.DataService = newsRecords;
    this.categories = {};
    this.rows = [];
    this.page = 1;
    this.per_page = 10;
    this.all_pages = 0;
    this.order = { 'id': "DESC" };

    this.save_type_process = false;
    this.form_info = {};
    this.empty_form_info = {
      'id': 0,
      'image': '',
      'title': '',
      'content': '',
      'type_id': 0,
      'publication_date' : getDateFormat('y-m-d'),
      'active': 1
    };

    this.state = {
      'has_data': false,
      'show_popup': false
    };
  }

  async changePage(page_number = 1) {
    this.page = page_number;
    await this.getDataList();
  }

  async changeOrder(new_order = {}) {
    this.order = new_order;
    await this.getDataList();
  }

  openAddNewForm() {
    this.form_info = {};
    Object.assign(
      this.form_info,
      this.empty_form_info
    );
    this.popupToggle();
  }

  openEditForm(row_for_edit = {}) {
    this.form_info = {};
    Object.assign(
      this.form_info,
      row_for_edit
    );
    this.form_info.publication_date = getDateFormat('y-m-d', new Date(this.form_info.publication_date || null));
    this.popupToggle();
  }

  popupToggle() {
    this.setState({
      'show_popup': !this.state.show_popup
    });
  }

  async saveCallback(info_from_form = {}) {
    let saved = null;
    
    if (this.form_info.id) {
      saved = await this.DataService.nr_update(info_from_form);

    } else {
      saved = await this.DataService.nr_add(info_from_form);
    }

    if (!saved) {
      window.alert(getStaticText('save_error'));
    } else {
      window.alert(getStaticText('save_success'));
      this.page = 1;
      this.popupToggle();
      await this.getDataList();
    }
  }

  async deletePost(post_for_delete) {

    if (!window.confirm(getStaticText('remove_confirm_text')))
      return false;

    let result = await this.DataService.nr_remove(post_for_delete.id);

    if (!result) {
      window.alert(getStaticText('remove_error'));
    } else {
      window.alert(getStaticText('remove_success'));
      this.page = 1;
      this.getDataList();
    }
  }

  async getDataList() {
    this.setState({ 'has_data': false });

    let list_response = await this.DataService.nr_list({
      'page': this.page,
      'per_page': this.per_page,
      'order': this.order
    });
    if (typeof (list_response.rows) !== 'undefined') {
      this.rows = list_response.rows;
      this.all_pages = list_response.all_pages;
    }

    this.setState({ 'has_data': true });
  }

  async componentDidMount() {
    let categories_response = await newsCategories.nc_list({
      'page': 1,
      'per_page': 0,
      'order': this.order
    });

    if (typeof (categories_response.rows) !== 'undefined') {
      for (let key in categories_response.rows) {
        this.categories[categories_response.rows[key].id] = categories_response.rows[key].name;
      }
    }

    await this.getDataList();
  }

  render() {
    let content = null;

    if (!this.state.has_data) {
      content = (
        <div className="col-lg-12 text-center"><Spinner /></div>
      );
    } else {
      content = (
        <>
          <div className="col-lg-12 os-text-right">
            <button
              className="btn btn-success text-white"
              onClick={this.openAddNewForm.bind(this)}
            >
              {getStaticText('nr_btn_add_news')}
            </button>
          </div>

          <Popup
            className="os-popup"
            closeOnEscape={false}
            open={this.state.show_popup}
            closeOnDocumentClick={false}
          >
            <>
              <div className="os-popup-header">
                <span className="op-popup-title">
                  {this.form_info.id ? getStaticText('nr_edit_popup_title') : getStaticText('nr_add_new_popup_title')}
                </span>
                <button
                  className="os-popup-close-button"
                  onClick={this.popupToggle.bind(this)}
                >
                  <i className={icons.news_remove_icon} />
                </button>
              </div>

              <div className="os-popup-body">
                <Form
                  info={this.form_info}
                  sections={{
                    'rtac_form': {
                      'fields': {
                        'image': {
                          'type': 'input_image',
                          'name': 'image',
                          'getDefaultValue': (value) => { return typeof (value) === 'string' ? this.DataService.nr_getImageUrl(value) : value; },
                          'label': getStaticText('nr_img_empty_title')
                        },
                        'title': {
                          'type': 'input_text',
                          'name': 'title',
                          'label': getStaticText('nr_add_form_title')
                        },
                        'type_id': {
                          'type': 'input_select',
                          'name': 'type_id',
                          'label': getStaticText('nr_form_type_id_input_label'),
                          'options': Object.assign({ '0': getStaticText('nr_form_type_id_input_empty_row') }, this.categories)
                        },
                        'content': {
                          'type': 'input_html',
                          'name': 'content',
                          'label': getStaticText('nr_add_form_content')
                        },
                        'publication_date': {
                          'type': 'input_text',
                          'name': 'publication_date',
                          'label': getStaticText('nr_add_form_publication_date')
                        },
                        'active': {
                          'type': 'input_checkbox',
                          'name': 'active',
                          'label': getStaticText('nr_add_active')
                        }
                      }
                    }
                  }}
                  formDataType="FormData"
                  buttonLabel={this.form_info.id ? getStaticText('nr_btn_update_news') : getStaticText('nr_btn_add_news')}
                  saveInfoCallback={this.saveCallback.bind(this)}
                />
              </div>
            </>
          </Popup>

          <div className="col-lg-12 pt-3">
            <Table
              currentOrder={this.order}
              changeOrderCallback={this.changeOrder.bind(this)}
              header={{
                'id': {
                  'label': getStaticText('nr_id_table'),
                  'sortButton': true
                },
                'title': {
                  'label': getStaticText('nr_title_table'),
                  'sortButton': true
                },
                'type_id': {
                  'label': getStaticText('nr_form_type_id_input_label'),
                  'sortButton': true
                },
                'active': {
                  'label': getStaticText('nr_active_table'),
                  'sortButton': true
                },
                'action': {
                  'label': getStaticText('nr_action_table'),
                  'sortButton': false
                }
              }}
              body={[
                (row) => { return row.id; },
                (row) => { return row.title; },
                (row) => { return this.categories[row.type_id] || ''; },
                (row) => { return row.active ? getStaticText('nr_active_yes') : getStaticText('nr_active_no'); },
                (row) => {
                  return (
                    <>
                      <button
                        onClick={this.openEditForm.bind(this, row)}
                        title={getStaticText('nr_edit_button_title')}
                        className="btn btn-sm btn-info text-white os-mr-1"
                      >
                        <span className={icons.news_edit_icon} />
                      </button>
                      <button
                        onClick={this.deletePost.bind(this, row)}
                        className="btn btn-sm btn-danger text-white"
                        title={getStaticText('nr_delete_button_title')}
                      >
                        <span className={icons.news_trash_icons} />
                      </button>
                    </>
                  );
                }
              ]}
              rows={this.rows}
              page={this.page}
              allPages={this.all_pages}
              changePageCallback={this.changePage.bind(this)}
              emptyRowsMessage={getStaticText('nr_list_empty')}
            />
          </div>

        </>
      );
    }

    return (
      <div className="row">
        <div className="col-lg-12">
          <h2>{getStaticText('nr_title')}</h2>
        </div>
        {content}
      </div>
    );
  }

}

export default NewsRecords;